import { createContext } from 'react'

export const StickyContext = createContext({
	CellStickyRow: () => {},
	CellStickyColumn: () => {},
	rowHeight: 0,
	columnWidths: [],
	columnRights: []
})
